import { Autocomplete, Box, Button, Drawer, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { ImagePaths } from '../../../Utility/ImagePaths';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { DateTime } from 'luxon';
import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents';
import { formatDate } from '../../../Components/CommonFunctions/CommonFunctions';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';

class TestwiseSummaryReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: 1,
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilterDatas: {},
            TestwiseSummaryData: [],
            GroupDataList: [],
            testConfigData: [],
            Groupsearch: [],
            Testsearch: [],
            TestTotalCount: 0,
            TotalOPCount: 0,
            TotalIPCount: 0,
            TotalLabCount: 0,
            InHouseCount: 0,
            OutSourceCount: 0,
            disableBtn: false,
        }
    }

    componentDidMount() {
        this.getTestWiseData()
        this.getTestGroupData()
        this.getTestData()
    }
  LoaderFunction =(key)=>{
    this.setState({
        isLoader : key
    })
  }
    getTestWiseData = () => {
        try {
            this.LoaderFunction(true)
            let grpName = []; this.state.Groupsearch.forEach(element => grpName.push(element.name))
            let testName = []; this.state.Testsearch.forEach(element => testName.push(element.test_name))
            this.setState({disableBtn: true})
            RestAPIService.getAll(Serviceurls.LAB_TEST_BASED_LIST_GET + `?report_type=overview&test_name=${testName}&grp_name=${grpName}&from_date=${this.state.fromDate}&to_date=${this.state.toDate}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            TestwiseSummaryData: response.data.data.result,
                            InHouseCount: response.data.data?.total_in_house,
                            OutSourceCount: response.data.data?.total_outsource,
                            TestTotalCount: response.data.data?.total_test_count,
                            TotalOPCount: response.data.data?.total_op_count,
                            TotalIPCount: response.data.data?.total_ip_count,
                            TotalLabCount: response.data.data?.total_self_count,
                            FilteredFromDate: this.state.fromDate,
                            FilteredToDate: this.state.toDate,
                            disableBtn: false,
                        },()=>{this.LoaderFunction(false)})
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === 'fail') {
                        this.LoaderFunction(false)
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction(false)
                        this.errorMessage(error.message)
                    }
                    this.setState({disableBtn: false})
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
            this.setState({disableBtn: false})
        }
    }

    getTestGroupData = () => {
        try {
            RestAPIService.getAll(Serviceurls.LAB_TEST_GROUP_GET)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            GroupDataList: response.data.data
                        })
                    }
                }).catch(e => {
                    this.setState({
                        isErrorMsg: true,
                        isErrorMsgText: e.message
                    })
                })

        } catch (e) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: e.message
            })
        }
    }

    getTestData = () => {
        try {
            RestAPIService.getAll(Serviceurls.LAB_TEST_CONFIG_GET + `?only_test_name=${true}`)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            testConfigData: response.data.data
                        })
                    }
                }).catch(e => {
                    this.setState({
                        isErrorMsg: true,
                        isErrorMsgText: e.message
                    })
                })

        } catch (e) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: e.message
            })
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t('Filter')}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={this.state.GroupDataList}
                            getOptionLabel={(option) => (option?.name)}
                            value={this.state.Groupsearch}
                            onChange={(event, newValue) => {
                                this.setState({ Groupsearch: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Select Group')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={this.state.testConfigData}
                            getOptionLabel={(option) => (option?.test_name)}
                            value={this.state.Testsearch}
                            onChange={(event, newValue) => {
                                this.setState({ Testsearch: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Select Test')}
                                />
                            )}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                Groupsearch: [],
                                Testsearch: [],
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                            },
                                () => this.getTestWiseData())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small" emed_tid='TestWiseSummary_Report_FilterSearch_btn' disabled={this.state.disableBtn}
                        onClick={() => {
                            this.getTestWiseData()
                            this.setState({ FilterOpen: false })
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        })
    }

    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.FilteredFromDate) },
            { label: "To Date", value: formatDate(this.state.FilteredToDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }
    getTestWiseSummaryReportExcel = () => {
        try {
            let grpName = []; this.state.Groupsearch.forEach(element => grpName.push(element.name))
            let testName = []; this.state.Testsearch.forEach(element => testName.push(element.test_name))
            this.setState({disableBtn: true})
            RestAPIService.excelGet(Serviceurls.LAB_TEST_BASED_LIST_GET + `?report_type=overview&test_name=${testName}&grp_name=${grpName}&from_date=${this.state.fromDate}&to_date=${this.state.toDate}&export_type=excel`)
                .then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data;
                        let filename = response.headers["content-disposition"]?.split("filename=")[1]
                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                    }
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                    this.setState({ disableBtn: false });
                });
        } catch (error) {
            this.errorMessage(error.message);
            this.setState({ disableBtn: false });
        }
    }

    getTestwisesumaryPrint = () => {
        try {
            let grpName = []; this.state.Groupsearch.forEach(element => grpName.push(element.name))
            let testName = []; this.state.Testsearch.forEach(element => testName.push(element.test_name))
            this.setState({ disableBtn: true })
            RestAPIService.getAll(Serviceurls.LAB_TEST_BASED_LIST_GET + `?report_type=overview&test_name=${testName}&grp_name=${grpName}&from_date=${this.state.fromDate}&to_date=${this.state.toDate}&export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    this.setState({ disableBtn: false })
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                    this.setState({
                        disableBtn: false,
                    })
                })
        } catch (error) {
            this.setState({
                disableBtn: false,
            })
            this.errorMessage(error.message);
        }
    }

    render() {
        this.state.TestwiseSummaryData.forEach((element, index) => element.sno = index + 1)
        const { t } = this.props
        const columns = [
            {
                field: "grp_name", headerName: t("Group Name"), flex: 0.153,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.grp_name?.length > 25 ?
                    <Tooltip placement='top' title={params?.row?.grp_name} arrow><div>{params?.row?.grp_name.slice(0, 25) + "..."}</div></Tooltip>
                    : params?.row?.grp_name ? params?.row?.grp_name : "-"}</Box>)
            },
            {
                field: "test_name", headerName: t("Test Name"), flex: 0.153,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.test_name?.length > 25 ?
                    <Tooltip placement='top' title={params?.row?.test_name} arrow><div>{params?.row?.test_name.slice(0, 25) + "..."}</div></Tooltip>
                    : params?.row?.test_name ? params?.row?.test_name : "-"}</Box>)
            },
            {
                field: "in_house", headerName: `${t("In House")}`, flex: 0.123, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.in_house ? params?.row?.in_house : "0"}</Box>)
            },
            {
                field: "outsource", headerName: `${t("Out Source")}`, flex: 0.123, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.outsource ? params?.row?.outsource : "0"}</Box>)
            },
            {
                field: "op_count", headerName: t("OP Count"), flex: 0.123, type: "number", 
                renderCell: (params) => ( <Box>{params?.row?.op_count || "0"}</Box> )
            },
            { 
                field: "ip_count", headerName: t("IP Count"), flex: 0.123, type: "number", 
                renderCell: (params) => ( <Box>{params?.row?.ip_count || "0"}</Box> )
            },
            { 
                field: "self_count", headerName: t("Lab Count"), flex: 0.123, type: "number", 
                renderCell: (params) => (<Box>{params?.row?.self_count || "0"}</Box> )
            },
            {
                field: "test_count", headerName: `${t("Total Test Count")}`, flex: 0.123, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.test_count ? params?.row?.test_count : "0"}</Box>)
            }
        ]
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        {AmountsCard(t("In House Count"), this.state.InHouseCount, true)}
                        {AmountsCard(t("Out Source Count"), this.state.OutSourceCount, true)}
                        {AmountsCard(t("Total Test Count"), this.state.TestTotalCount, true)}
                        {AmountsCard(t("Total OP Count"), this.state.TotalOPCount, true)}
                        {AmountsCard(t("Total IP Count"), this.state.TotalIPCount, true)}
                        {AmountsCard(t("Total Lab Count"), this.state.TotalLabCount, true)}
                    </Box>
                    
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Box>
                        <Button className='eMed_usrconf_btn' onClick={() => { this.getTestwisesumaryPrint() }}>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                        </Button>
                         <Button className='eMed_usrconf_btn' onClick={() => { this.getTestWiseSummaryReportExcel() }}>
                            <img src={ImagePaths.ExportIcon.default} alt="filter" className='eMed_action_img' />
                         </Button>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.TestwiseSummaryData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        loading={this.state.isLoader}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}
export default withTranslation()(TestwiseSummaryReport)